<template>
  <div>
    <b-modal
      id="modal-rkipopup-module"
      ref="modal-rkipopup-module"
      centered
      title="Register Debtor in RKI"
      ok-title="Register"
      :ok-disabled="!rkiCustomerId || loader"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="manualRKIEntries.length > 0"
          variant="warning"
          show
        >
          <div class="alert-body">
            <p v-if="manualRKIEntries.length === 1">
              <strong>{{ manualRKIEntries[0] }}</strong> {{ $t('DEBITA_iS_ALREADY_REGISTERED') }}
              {{ $t('DEBITA_RKI_PROCEED') }}
            </p>

            <p v-else-if="manualRKIEntries.length === 2">
              <strong>{{ manualRKIEntries[0] }}</strong> {{ $t('DEBITA_AND') }}
              <strong>{{ manualRKIEntries[1] }}</strong> {{ $t('DEBITA_ARE_ALREADY_REGISTERED') }}
              {{ $t('DEBITA_RKI_PROCEED') }}
            </p>

            <p v-else>
              <span
                v-for="(debtor, index) in manualRKIEntries"
                :key="index"
              >
                <strong>{{ debtor }}</strong>
                <template v-if="index < manualRKIEntries.length - 2">, </template>
                <template v-else-if="index === manualRKIEntries.length - 2">{{ $t('DEBITA_AND') }}</template>
              </span>
              {{ $t('DEBITA_ARE_ALREADY_REGISTERED') }} {{ $t('DEBITA_RKI_PROCEED') }}
            </p>

          </div>
        </b-alert>

        <b-alert
          v-if="errorMsg || rkiAwaitDeletion || rkiCustomerId === false"
          :variant="rkiCustomerId === false ? 'danger' : 'warning'"
          show
        >
          <h4 class="alert-heading">
            {{ rkiCustomerId === false ? 'Error' : (rkiAwaitDeletion ? 'Note' : $t('DEBITA_ERROR')) }}
          </h4>
          <div class="alert-body">
            <span v-if="errorMsg">{{ errorMsg }}</span>
            <span v-else-if="rkiAwaitDeletion">{{ rkiAwaitDeletion }}</span>
            <span v-else-if="rkiCustomerId === false">
              {{ $t('DEBITA_RKI_CUSTOMER_ERROR') }}
            </span>
          </div>
        </b-alert>
        <form
          ref="registrationform"
        >
          <validation-observer
            ref="registrationRules"
            tag="form"
          >
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  name="Fundament Kode"
                  rules="required"
                >
                  <b-form-group
                    label="Fundament Kode"
                    label-for="send-by"
                    :state="errors.length > 0 ? false:null"
                  >
                    <v-select
                      v-model="fundamentKode"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="fundamentKodeOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="awaitType"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                md="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Fundament Dato"
                  rules="required"
                >
                  <b-form-group
                    label="Fundament Dato"
                    label-for="email"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-form-datepicker
                      v-if="fundamentKode === '0'"
                      id="datepicker-dateformat2"
                      v-model="fundamentDato"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      :max="zeroMaxDate"
                      :min="zeroMinDate"
                      locale="da"
                    />
                    <b-form-datepicker
                      v-else
                      id="datepicker-dateformat2"
                      v-model="fundamentDato"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      :max="maxDate"
                      locale="da"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="fundamentKode !== '0'"
                md="12"
              >
                <validation-provider
                  v-slot="{ validate, errors }"
                  name="File"
                  rules="required"
                >
                  <b-form-group
                    label="Fundament Fil"
                    label-for="fil"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-form-file
                      id="fil"
                      ref="button-file"
                      v-model="file"
                      @change="validate($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInvalidFeedback, BAlert, BOverlay, BFormFile, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { EventBus } from '@/event-bus'

export default {
  components: {
    BFormDatepicker,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  props: {
    processID: {
      type: Number,
      required: true,
    },
    showSkipModal: {
      type: Function,
      required: true,
    },
    rkiAwaitDeletion: {
      type: String,
      required: true,
    },
    rkiCustomerId: {
      type: Boolean,
      required: true,
    },
    manualRKIEntries: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxDate: this.formatDate(new Date()),
      zeroMaxDate: this.zeroMaxFormatDate(new Date()),
      zeroMinDate: this.zeroMinFormatDate(new Date()),
      required,
      fundamentKode: null,
      fundamentDato: null,
      file: null,
      errorMsg: null,
      loader: false,
      caseID: this.$route.params.id,
      fundamentKodeOptions: [
        { label: 'A - Betalingspåkrav 1. Påtegning', value: 'A' },
        { label: 'B - Betalingspåkrav 2. Påtegning', value: 'B' },
        { label: 'C - Stævning', value: 'C' },
        { label: 'D - Fogedsag, fremlagt og opgjort', value: 'D' },
        { label: 'E - Dom', value: 'E' },
        { label: 'F - Insolvenserklæring I anden sag', value: 'F' },
        { label: 'I - Konkurs', value: 'I' },
        { label: 'K - Tvangsakkord indledt', value: 'K' },
        { label: 'L - Retsforlig', value: 'L' },
        { label: 'P - Fogedretsrekvisation', value: 'P' },
        { label: 'S - Offentlig indberetning', value: 'S' },
        { label: 'T - Tvangsauktion (fordring opgjort)', value: 'T' },
        { label: 'U - Tvangsauktion (udlæg)', value: 'U' },
        { label: 'W - Gældssanering, indledt', value: 'W' },
        { label: 'Y - Skyldnerklæring', value: 'Y' },
        { label: 'Z - Frivilligt forlig', value: 'Z' },
        { label: '0 - Intet fundament', value: '0' },
      ],
    }
  },
  watch: {
    fundamentKode: {
      handler() {
        this.fundamentDato = null
      },
    },
  },
  created() {
  },
  methods: {
    isNumber(event) {
      // Allow only numbers (0-9)
      const charCode = event.charCode ? event.charCode : event.keyCodea
      if (charCode < 48 || charCode > 57) {
        event.preventDefault()
      }
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    zeroMinFormatDate(date) {
      date.setDate(date.getDate() - 15)
      date.setFullYear(date.getFullYear() - 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    zeroMaxFormatDate(date) {
      date.setDate(date.getDate() - 15)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        this.$refs.registrationRules.validate().then(success => {
          if (success) {
            this.loader = true
            const form = new FormData()
            form.append('fundament_code', this.fundamentKode)
            form.append('fundament_date', this.fundamentDato)
            form.append('fundament_file', this.file ? this.file : '')
            form.append('case_id', this.caseID)
            form.append('process_id', this.processID)
            axios.post('/rki/register-debtor', form).then(response => {
              if (response.status) {
                this.$refs['modal-rkipopup-module'].hide()
                if (response.data.data.skip) {
                  this.showSkipModal(response.data.data.message.trim())
                } else {
                  EventBus.$emit('refreshModules')
                  EventBus.$emit('refreshDebtorsSection')
                }
              }
              // window.location.reload()
            }).catch(err => {
              if (err.response.data.message) {
                this.loader = false
                const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
                this.errorMsg = msg
                // console.log('this.errorMsg ', this.errorMsg)
                // this.alertErrors.push(err.response.data.message)
                // console.log('this.alertErrors ', this.alertErrors)
              }
            })
          } else {
            this.loading = false
            reject()
          }
        })
      })
    },
    resetModal() {
      this.fundamentKode = null
      this.fundamentDato = null
      this.file = null
      this.errorMsg = null
      this.loader = false
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
